import React from 'react';
import {isServerSide} from 'tunnel-commande/src/utils';

class CookieBotContent extends React.Component<any, any> {
  private loaded: boolean | undefined;

  constructor(props: any) {
    super(props);
    this.state = {};

    this.loaded = false;
  }

  static getInitialProps({query}: {query: any}) {
    return {token: query.token, namespacesRequired: ['common']};
  }

  componentDidMount(): void {
    if(this.props.tag == 'politique-de-cookies') {
      this.configScript();
    }
  }
  componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
    if(prevProps.tag != this.props.tag && this.props.tag !== 'politique-de-cookies') {
      this.removeScript();
    } else if (prevProps.tag != this.props.tag && this.props.tag == 'politique-de-cookies') {
      this.configScript();
    }
  }

  removeScript(): void{
    if(!isServerSide()) {
      const contentCookies = document.getElementById('CookieBotContent');
      if(contentCookies) {
        contentCookies.remove();
        this.loaded = false;
      }
    }
  }
  configScript(): void{
    if(!isServerSide()) {
      if (!this.loaded) {
        const contentCookies = document.createElement('script');
        const contentCookiesDiv = document.createElement('div');
        contentCookies.defer = true;
        contentCookies.src = 'https://consent.cookiebot.com/da3d5ec8-b17a-40fa-b7eb-0edfedf4e2c1/cd.js';
        contentCookies.id = "CookieDeclaration";
        contentCookiesDiv.id = "CookieBotContent";
        const s = document.getElementById('CookieBotContentWrapper');

        if(s) {
          s.appendChild(contentCookiesDiv);
          contentCookiesDiv.appendChild(contentCookies);
        }

        contentCookies.addEventListener('load', () => {
          this.loaded = true;
        });
      }
    }
  }

  render() {
    return false;
  }
}
export default CookieBotContent;
